import { jsx } from "react/jsx-runtime";
import { useEffect } from "react";
const FeishuLogin = ({ feishuParams }) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://lf-package-cn.feishucdn.com/obj/feishu-static/lark/passport/qrcode/LarkSSOSDKWebQRCode-1.0.3.js";
    script.async = true;
    document.body.appendChild(script);
    script.onload = () => {
      if (window.QRLogin) {
        const { appId, redirectUri } = feishuParams;
        const redirectUrl = encodeURIComponent(redirectUri);
        const goto = `https://passport.feishu.cn/suite/passport/oauth/authorize?client_id=${appId}&redirect_uri=${redirectUrl}&response_type=code&state=STATE`;
        const QRLoginObj = window.QRLogin({
          id: "login_container",
          goto,
          style: "width:260px;height:260px;border:0"
          // 可选的，二维码html标签的style属性
        });
        const handleMessage = async (event) => {
          if (QRLoginObj.matchOrigin(event.origin) && QRLoginObj.matchData(event.data)) {
            const loginTmpCode = event.data.tmp_code;
            window.location.href = `${goto}&tmp_code=${loginTmpCode}`;
          }
        };
        window.addEventListener("message", handleMessage, false);
      }
    };
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return /* @__PURE__ */ jsx(
    "div",
    {
      id: "login_container",
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }
    }
  );
};
var FeishuLogin_default = FeishuLogin;
export {
  FeishuLogin_default as default
};
